<template>
  <div>
    <div id="listloader" v-if="isLoading">
            <div class="listloader"></div>
        </div>
    <b-list-group flush>
      <b-list-group-item v-for="(nestedItem, nestedIndex) in nestedItems" :key="nestedIndex">
        <b-button variant="warning" class="w-100 text-left" @click="toggleNestedCollapse(nestedIndex,nestedItem)">
          <b-row>
            <b-col sm="12" title="Vehicle Number" class="text-center">{{nestedItem.vehicle_no}}
            </b-col>
          </b-row>
        </b-button>
        <!-- :visible="activeNestedCollapse === nestedIndex" -->
        <b-collapse @hide="vehicleDrawerClose" :visible="activeNestedCollapse === nestedIndex" :id="'nested-collapse-' + nestedIndex">
          <b-card>
            <b-card-body>
              <b-card-text>
                <!-- {{ nestedItem.vehicle_no}} -->
                <b-row>
                  <b-col md="12">
                    <div>
                      <ul class="nav nav-tabs nav-justified">
                        <li class="nav-item">
                          <a @click="activeTab = 0,dailyTrip('Mps')" class="nav-link " :class="{'active' : isActiveTab(0)}">MPS Level</a>
                        </li>
                        <li class="nav-item">
                          <a @click="activeTab = 1,dailyTrip('Load')" class="nav-link " :class="{'active' : isActiveTab(1)}">Load Level</a>
                        </li>
                      </ul>
                    </div>
                  </b-col>

                  </b-row>
                  <b-row>
                    <b-col sm="12" class="text-right">
                     <p > <b>Total Records :<span style="color:red;">{{ totalRows }}</span></b> </p>
                   </b-col> 
                  <b-col sm="12">
                    <b-row>
                        <b-col v-if="selected_status=='Load'">
                          <b-row>
                            <b-col>
                              <pre><h6>Are Shipments Out For Delivery</h6></pre>
                            </b-col>
                            <b-col>
                              <b-button @click="checkbuttonvisible()">Yes</b-button>&nbsp;
                              <b-button @click="clicknobutton()">No</b-button>
                            </b-col>
                          </b-row>
                        </b-col>
                        <b-col class="text-right">
                          <button class="btn btn-md btn-primary "  type="submit" @click="submitTrip('form-2',loaditem.tripid)" :disabled="isReadOnly" v-if="submitbuttonvisible==true && selected_status=='Load'">Submit</button>

                          <button class="btn btn-md btn-primary"  type="submit" :disabled="isReadOnly"  @click="openmodeldirectMode()" v-if="selectparentawb.length>0 && selected_status=='Load'">Submit</button>

                          <!-- <button class="btn btn-md btn-primary"  type="submit" @click="directMode()" v-if="selectparentawb.length>0">Submit</button> -->
                        </b-col>
                      </b-row>
                      <br>
                      <b-row v-if="selected_status=='Load'">
                        <b-col class="d-flex flex-flow justify-content-start">
                          <span><i class="fa fa-file-text-o p-1" aria-hidden="true" style="font-size:large;color:#1b8eb7;"></i> Eway Bill PDF</span>
                          <span><i class="fa fa-file p-1" aria-hidden="true" style="font-size:large;color:#1b8eb7;"></i> WMS Invoice PDF</span>
                          <span><i class="fa fa-file-text p-1" aria-hidden="true" style="font-size:large;color:#1b8eb7;"></i>Transport Doc PDF</span>
                        </b-col>
                        <b-col class="d-flex flex-flow justify-content-end">
                          <!-- <a :href="doc_all_file_url" target="_blank">
                            
                          </a> -->
                          <!-- {{ doc_all_file_url  }} -->
                          <!-- <a :href="doc_all_file_url" target="_blank"> -->
                            <b-button variant="outline-primary" title="Download All Document" v-if="all_doc_flag=='Yes'" @click="downloadAllDocPdf(loaditem.tripid)"><i class="fa fa-download" aria-hidden="true"></i></b-button>
                          <!-- </a> -->
                        </b-col>
                        <!-- {{ loaditem }} -->
                      </b-row>
                  </b-col>
                   <!-- <b-col sm="12" class="text-right">
                  <button class="btn btn-md btn-primary "  type="submit" @click="submitTrip('form-2',loaditem.tripid)">Submit</button>
                </b-col> -->
		          	  <b-col md="12">
                    <div v-if="selected_status=='Load' && isvisibledataselect== true" style="text-align: justify;">
                          <pre><h6>Please Select Shipments Which are Out For Delivery</h6></pre>
                          <input type='checkbox' @click='checkAll()' v-model='isCheckAll' style="margin: 10px;"> Select All
                    </div>
		                <b-table show-empty responsive   :items="tripItems" :busy="isBusy"    :current-page="currentPage"  :fields="tripfields"   :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered" :tbody-tr-class="rowClass"> 

			                <div slot="table-busy" class="text-center text-danger my-2">
			                    <b-spinner class="align-middle"></b-spinner>
			                    <strong>Loading...</strong>
			                </div> 
		               
                      <template slot="checkbox" slot-scope="row">
                            <input type='checkbox' v-bind:value='row.item.parentawb' v-model='selectparentawb' @change='updateCheckall()' style="margin: 10px;">
                          </template>
                      <template slot="parentawb" slot-scope="row">
                        <span v-if="selected_status!='Load'">{{row.item.parentawb}}</span>
                       
                        <div class="d-flex flex-column" v-if="selected_status=='Load'">
                          <span>{{row.item.parentawb}}</span>
                          <sub class="d-flex flex-flow justify-content-around">
                            <a :href="row.item.ewaybill_file?row.item.ewaybill_file:row.item.taxilla_ewaybill_doc" v-if="row.item.ewaybill_file || row.item.taxilla_ewaybill_doc" target="_blank"><i class="fa fa-file-text-o" aria-hidden="true" style="font-size:large;"  title="Download Eway Bill"></i></a>
                            <a :href="row.item.wms_invoice_url" v-if="row.item.wms_invoice_url" target="_blank"><i class="fa fa-file" aria-hidden="true" style="font-size:large;" title="Download WMS Invoice"></i></a>
                            <a :href="row.item.transport_doc" v-if="row.item.transport_doc" target="_blank" title="Download Transport Doc"><i class="fa fa-file-text" aria-hidden="true" style="font-size:large;" @click="updateDowloadFlag(row.item)"></i></a>
                          </sub>
                        </div>
                      </template>
			                <template slot="actions" slot-scope="row">
                         <b-button size="sm" class="mr-1"  href=""  data-toggle="tooltip" @click="deallocateShipmentConfirm(row.item.parentawb,Mps)" :disabled="isReadOnly"> Deallocate
                        </b-button> 
                       
                        <!-- <i
                          class="fa fa-download p-1"
                          aria-hidden="true"
                          v-b-tooltip.hover
                          title="Download Document"
                          style="font-size:25px;"
                          v-if="selected_status=='Load' && row.item.wms_invoice_url && row.item.ebn && (row.item.mpscount.split('/').shift()==row.item.mpscount.split('/').pop())"
                          @click="downloadEwayBill(row.item)"
                        ></i> -->
			                </template>
                      <template slot="download" slot-scope="row">
                        <div  v-if="row.item.loadpotype=='B2D'">
                          <div  v-if="row.item.download_again_flag!=0">
                            <b-button size="sm" title="Download Eway Bill Again" v-if="row.item.wms_invoice_url && row.item.ebn && (row.item.mpscount.split('/').shift()==row.item.mpscount.split('/').pop())" @click="onclickB2D(row.item)">
                            Download Again
                          </b-button>
                          </div>
                          <div  v-else>
                            <i class="fa fa-download p-1" aria-hidden="true" v-b-tooltip.hover title="Download Eway Bill" style="font-size:25px;"  v-if="row.item.wms_invoice_url && row.item.ebn && (row.item.mpscount.split('/').shift()==row.item.mpscount.split('/').pop())" @click="onclickB2D(row.item)"
                          ></i>
                          </div>
                          <i class="fa fa-cloud-download" aria-hidden="true" title="Download Taxilla EwayBill" style="font-size:25px;" v-if="row.item.ebn  && (row.item.mpscount.split('/').shift()==row.item.mpscount.split('/').pop())"  @click="downloadDirectTaxillaEwayBill(row.item)"></i>
                        </div>
                        <div v-else>
                          <!-- {{ row.item.download_again_flag }} -->
                          <div  v-if="row.item.download_again_flag!=0">
                            <!-- <b-button size="sm" class="mr-1"  title="Download Again" @click="downloadEwayBill(row.item)" > Download Again
                           </b-button>  -->
                            <!-- <i class="fa fa-check-square-o" aria-hidden="true" title="Download Again" style="font-size:25px;" v-if="row.item.wms_invoice_url && row.item.ebn && (row.item.mpscount.split('/').shift()==row.item.mpscount.split('/').pop())" @click="downloadEwayBill(row.item)"
                          ></i> -->
                          <b-button size="sm" title="Download Eway Bill Again" v-if="row.item.wms_invoice_url && row.item.ebn && (row.item.mpscount.split('/').shift()==row.item.mpscount.split('/').pop())" @click="downloadEwayBill(row.item)">
                            Download Again
                          </b-button>
                          </div>
                          <div  v-else>
                            <i class="fa fa-download p-1" aria-hidden="true"  title="Download Eway Bill" style="font-size:25px;" v-if="row.item.wms_invoice_url && row.item.ebn && (row.item.mpscount.split('/').shift()==row.item.mpscount.split('/').pop())" @click="downloadEwayBill(row.item)"
                          ></i>
                          </div>
                          <i class="fa fa-cloud-download" aria-hidden="true" title="Download Taxilla EwayBill" style="font-size:25px;" v-if="row.item.ebn  && (row.item.mpscount.split('/').shift()==row.item.mpscount.split('/').pop())"  @click="downloadDirectTaxillaEwayBill(row.item)"></i>
                        </div>
                        <!-- <a :href="row.item.transport_doc" target="_blank" v-if="row.item.transport_doc"><i class="fa fa-download pl-1" aria-hidden="true" v-b-tooltip.hover title="Download Transport Document" style="font-size:x-large;" ></i></a> -->
                    </template>
                      
                      <template slot="mpscount" slot-scope="row">
                        <button v-b-tooltip.hover title="View Count Details" @click="viewProduct(row.item)" style="background-color:white !important;" class="btn btn-link">
                        <span style="color:#1b8eb7"> {{row.item.mpscount}}</span>
                        </button>
                        <button
                        v-if="isMismatch(row.item)"
                        class="btn btn-sm btn-danger ml-2"
                        @click="openMismatchPopup(row.item)"
                        v-b-tooltip.hover
                        title="Mismatch - View MPS Details"
                      >
                        View Mismatch
                      </button>
                      </template>
                      
		                </b-table>
                  </b-col>
                  <br>
                  <b-col md="12">
                      <div class="table-responsive-sm">
                        <h6>Total Loads</h6>
                        <table class="table  b-table table-bordered b-table-stacked-md">
                          <thead>
                            <tr>
                              <th>Trip Id</th>
                              <th>Total Loads</th>
                              <th>Total Boxes</th>
                              <th>Vehicle Physical Weight</th>
                              <th>Vehicle Weight Carrying</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-if="tripItems.length>0">
                              <td>{{loaditem.tripid}}</td>
                              <td>{{loaditem.totalloads}}</td>
                              <td>{{loaditem.totalboxes}}</td>
                              <td>{{loaditem.vehiclephysicalweight}}</td>
                              <td>{{loaditem.vehicleweightcarrying}}</td>
                            </tr>
                            <tr v-else>
                              <td colspan="12" class="text-center"> No Records Found</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
		              </b-col>
                  </b-row>
                  <b-modal size="lg" title="MPS Count Details" v-model="productdetailsModal" @ok="productdetailsModal = false" hide-footer>
              
                      <template slot="default" slot-scope="{ hide }">
                          <b-row>
                              <b-col sm="12" class="text-right">
                              <p> <b>Total Records :<span style="color:red;"> {{mpstotalRows}}</span></b> </p>
                              </b-col>   
                              <b-col sm="12">
                                  <b-table show-empty stacked="md"  :items="mpsitems"  :fields="mpsfields"  :current-page="mpscurrentPage"  :per-page="mpsperPage"     :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered"    :outlined="outlined" :busy="isBusyMps" >
                                  <div slot="table-busy" class="text-center text-danger my-2">
                                      <b-spinner class="align-middle"></b-spinner>
                                      <strong>Loading...</strong>
                                      </div>  
                                  <template slot="mpsvalue" slot-scope="row">
                                          <span>&#8377;{{row.item.mpsvalue}}</span>
                                          </template>
                                          <template slot="physicalweight" slot-scope="row">
                                          <span> {{row.item.physicalweight}} {{row.item.physicalweightunit}}</span>
                                          </template>
                                          <template slot="breadth" slot-scope="row">
                                          <span> {{row.item.breadth}} {{row.item.lbhunit}}</span>
                                          </template>
                                          <template slot="length" slot-scope="row">
                                          <span> {{row.item.length}} {{row.item.lbhunit}}</span>
                                          </template>
                                          <template slot="height" slot-scope="row">
                                          <span> {{row.item.height}} {{row.item.lbhunit}}</span>
                                          </template>
                                          <template slot="deliverystatus" slot-scope="row">
                                          <span v-if="row.item.deliverystatus=='INTransit'" style="color: red;"> {{row.item.deliverystatus}} </span>
                                          <span v-else> {{row.item.deliverystatus}} </span>
                                          </template>
                                          <template slot="shipmentstatus" slot-scope="row">
                                          <span v-if="row.item.deliverystatus=='INTransit'" style="color: red;">{{row.item.shipmentstatus}} </span>
                                          <span v-else>{{row.item.shipmentstatus}}</span>
                                          </template>
                                      
                                  </b-table> 
                              </b-col>
                          </b-row> 
                          <b-row>
                              <b-col md="6" class="my-1" v-if="mpstotalRows>10">
                              <b-pagination
                                      v-model="mpscurrentPage"
                                      :total-rows="mpstotalRows"
                                      :per-page="mpsperPage"
                                      class="my-0"
                                  ></b-pagination>
                          
                              </b-col> 
                          </b-row>
                          <div class="col-md-12 pull-right"> 
                              <div slot="footer" class="text-right">
                                  <b-button  size="sm" variant="danger" @click="modalCancel()">Close</b-button>
                              </div>
                          </div>
                      </template>
                      <template slot="modal-footer" slot-scope="{ cancel }">
                        <b-button size="sm" variant="danger" @click="modalCancel()" style="display:none">
                          Cancel
                        </b-button>
                      </template>
                  </b-modal>
  
                <b-modal size="lg" title="MPS Count Details" v-model="productdetailsModal" @ok="productdetailsModal = false" hide-footer>
                
                    <template slot="default" slot-scope="{ hide }">
                        <b-row>
                            <b-col sm="12" class="text-right">
                            <p> <b>Total Records :<span style="color:red;"> {{mpstotalRows}}</span></b> </p>
                            </b-col>   
        
                            <b-col sm="12"> 
                            <b-table show-empty stacked="md"  :items="mpsitems"  :fields="mpsfields"  :current-page="mpscurrentPage"  :per-page="mpsperPage"     :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered"    :outlined="outlined" :busy="isBusyMps" >
                                <div slot="table-busy" class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
        
                                <template slot="mpsvalue" slot-scope="row">
                                    <span>&#8377;{{row.item.mpsvalue}}</span>
                                </template>
                                
                                <template slot="physicalweight" slot-scope="row">
                                    <span> {{row.item.physicalweight}} {{row.item.physicalweightunit}}</span>
                                </template>
                                
                                <template slot="breadth" slot-scope="row">
                                    <span> {{row.item.breadth}} {{row.item.lbhunit}}</span>
                                </template>
        
                                <template slot="length" slot-scope="row">
                                    <span> {{row.item.length}} {{row.item.lbhunit}}</span>
                                </template>
                    
                                <template slot="height" slot-scope="row">
                                    <span> {{row.item.height}} {{row.item.lbhunit}}</span>
                                </template>
                                
                                <template slot="deliverystatus" slot-scope="row">
                                    <span v-if="row.item.deliverystatus=='INTransit'" style="color: red;"> {{row.item.deliverystatus}} </span>
                                    <span v-else> {{row.item.deliverystatus}} </span>
                                </template>
                    
                                <template slot="shipmentstatus" slot-scope="row">
                                    <span v-if="row.item.deliverystatus=='INTransit'" style="color: red;">{{row.item.shipmentstatus}} </span>
                                    <span v-else>{{row.item.shipmentstatus}}</span>

                                    <b-button v-if="row.item.is_shortage=='Yes' && row.item.shipmentstatus!='DispatchOutScan'" size="sm" class="text-right mt-3"
                                      variant="success"
                                      @click="fixMismatchAction(row.item)" ><span v-if="row.item.is_shortage=='Yes'" class="badge " style="background-color:rgb(23, 130, 109);color:white;font-size: 9px;padding: 3px; cursor: pointer;">SB</span>Fix Mismatch </b-button>

                                </template>
                                    
                                </b-table> 
                            </b-col>
                        </b-row> 
        
                        <b-row>
                            <b-col md="6" class="my-1" v-if="mpstotalRows>10">
                            <b-pagination
                                    v-model="mpscurrentPage"
                                    :total-rows="mpstotalRows"
                                    :per-page="mpsperPage"
                                    class="my-0"
                                ></b-pagination>
                            </b-col> 
                        </b-row>
        
                        <div class="col-md-12 pull-right"> 
                        
                            <div slot="footer" class="text-right">
                            

                          
                                <b-button class="text-right mt-3" size="sm" variant="danger" @click="modalCancel()">Close</b-button>
                            </div>
                        </div>
                    </template>
        
                    <template slot="modal-footer" slot-scope="{ cancel }">
                      <b-button size="sm" variant="danger" @click="modalCancel()" style="display:none">
                        Cancel
                      </b-button>
                    </template>
                    
                </b-modal>
        
                    <b-modal size="md" v-model="noModal" @ok="noModal = false" hide-footer hide-header>
                        <div class="text-center p-4">
                          Please Confirm If All the Loads Are In-Transit
                          &nbsp;
                          <br><br>
                          <b-button variant="primary" @click="nomodelclose()" :disabled="isReadOnly"> Confirm </b-button> &nbsp;&nbsp;
                          <b-button variant="danger" @click="nomodelCancel()"> Cancel</b-button>
                        </div>
                    </b-modal>
            
                    <b-modal size="md" v-model="directModemodel" @ok="directModemodel = false" hide-footer hide-header>
                        <div class="text-center p-4">
                          Please Confirm If the Selected Loads 
                          <strong v-for="load in selectparentawb"> {{load}} , </strong>
                          Are Out Of Delivery
                          &nbsp;
                          <br><br>
                          <b-button variant="primary" @click="directMode()" :disabled="isReadOnly"> Confirm </b-button> &nbsp;&nbsp;
                          <b-button variant="danger" @click="directmodelclose()"> Cancel</b-button>
                        </div>
                    </b-modal>

                    <b-modal
                      id="invalid-shipment-modal"
                      title="Invalid Shipment"
                      size="lg"
                      hide-footer
                      v-model="showInvalidModal"
                    >
                      <div id="listloader" v-if="isLoading">
            <div class="listloader"></div>
        </div>
                      <table class="table table-bordered">
                        <thead>
                          <tr>
                            <th>Invalid Shipment</th>
                            <th>Expirydate</th>
                            <th>EBN</th>
                            <th>EBN Generate</th>
                          </tr>
                        </thead>
                        <tbody v-html="invalidShipmentTableHtml"></tbody>
                      </table>
                    </b-modal>

              </b-card-text>
            </b-card-body>
          </b-card>
        </b-collapse>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>
<script>
  import CONSTANTS from '@/utils/constants'
  import Utils from '@/utils'
  import Vue from 'vue'
  // import mps_level from './mps_level.vue'
  // import load_level from './load_level.vue'
  export default {
    props: {
      nestedItems: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        activeNestedCollapse: null,
        dispalyonlyclickb2d : false,
        noneclickb2d : true,
        activeTab: '',
        // MPS Level Start
        tripItems: [],
        loaditem: [],
        tripfields:[],
        isBusy: false,
        totalRows: 0,
        apiMPSCallAllowed: false,
        isLoading: false,
        mpsTimeout: false,
        selected_hubid: '',
        selected_vehicle: '',
        // MPS Level End 

        filter:null,
  		sortBy:null,
  		sortDesc:false,
  		sortDirection:'asc',
  		bordered:true,
  		activeTab: 0,
  		selected_status:'Mps',
  		list: [],
      timer: '',
      loaditem:[],
      vehicleList:[],
      totalRows:0,
      productdetailsModal:false,
      mpsitems:[],
      mpsfields:[
        // { key: 'mpsid', label: 'MPS Id', sortable: true, sortDirection: 'desc' },
        { key: 'shippingid', label: 'MPS No', sortable: true, sortDirection: 'desc' },
        { key: 'mpsvalue', label: 'MPS Value', sortable: true, sortDirection: 'desc' },
        
        { key: 'length', label: 'Length', sortable: true, sortDirection: 'desc' },
        { key: 'breadth', label: 'Breadth', sortable: true, sortDirection: 'desc' },
          
          { key: 'height', label: 'Height', sortable: true, sortDirection: 'desc' },
        { key: 'physicalweight', label: 'Physical Weight', sortable: true, sortDirection: 'desc' },
        { key: 'deliverystatus', label: 'Delivery Status', sortable: true, sortDirection: 'desc' },
        { key: 'shipmentstatus', label: 'Shipment Status', sortable: true, sortDirection: 'desc' },
        // { key: 'deliverystatus', label: 'Delivery Status', sortable: true, sortDirection: 'desc' },
          
      ],
      isBusyMps:false,
      mpstotalRows: 0,
      mpscurrentPage: 1,
      mpsperPage: 10,
      MpsOrLoadListCount:0,
      isCheckAll:false,
      selectparentawb :[],
      isvisibledataselect : false,
      noModal :false,
      submitbuttonvisible : false,
      directModemodel :false,
      intervalId: null,
      apiLoadCallAllowed:false,
      isLoading: false,
      all_doc_flag:'',
      doc_all_file_url:'',
      showInvalidModal: false,
      invalidShipmentTableHtml: '',
      };
    },
    beforeDestroy () {
     this.apiMPSCallAllowed=false;
     this.mpsTimeout=null;
    // clearTimeout();
   },
    created() {
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      window.generateEBN = this.generateEBN;
    },
    methods: {
      isMismatch(item) {
      return item && item.loadcount !== item.boxcount;
      },
      openMismatchPopup(item) {
        this.productdetailsModal = true;   // open modal
        this.isLoading = true;
        this.isBusyMps = true;

        const obj = {
          parentawb: item.parentawb
        };

        this.$http
          .post(`${CONSTANTS.MISREPORT_API_URL}/getMPSListFromLoad`, obj)
          .then(res => {
            this.isLoading = false;
            this.isBusyMps = false;

            if (res.body.returnmsg === "successful") {
              this.mpsitems = res.body.returnvalue || [];
              this.mpstotalRows = this.mpsitems.length;
            } else {
              this.mpsitems = [];
              this.mpstotalRows = 0;
            }
          })
          .catch(() => {
            this.isLoading = false;
            this.isBusyMps = false;
          });
      },
      fixMismatchAction(item) {
  if (!item) return;

  this.isLoading = true;

  const obj = {
    parentawb: item.parentawb,
    shippingid: item.shippingid
  };

  this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/fixMismatchAPI`, obj)
    .then(res => {
      this.isLoading = false;
      const response = res.body;
      if (response.returnmsg.toLowerCase() === 'successful') {
        this.$fire({
          text: response.returnvalue.message || 'Mismatch Fixed Successfully',
          type: 'success'
        });
        this.productdetailsModal = false;
        this.dailyTrip(this.selected_status);
      } else {

        this.$fire({
          text: response.returnvalue,
          type: 'error'
        });

      }
    })
    .catch(() => {
      this.isLoading = false;

      this.$fire({
        text: 'Something went wrong',
        type: 'error'
      });
    });
},
      onclickB2D(data){
        this.$fire({
        text: 'Print Invoice Using A4 Paper ONLY',
        type: 'success',
      }).then((result) => {
        if (result.value) {
          this.downloadEwayBill(data); // Make sure 'data' is defined or replace it with the actual data
        }
      }); 

        // this.$fire({
        //     text: 'Print Invoice Using A4 Paper ONLY',
        //     type: "success",
        //     onOk: () => {
        //         // Call your function here
        //         this.downloadEwayBill(data);
        //     }
        // });

      },

      toggleNestedCollapse(nestedIndex, nestedItem) {
        // alert("inn");
        // console.log("nestedIndex", nestedIndex, nestedItem);
        // Toggle the nested collapse based on the current state
        this.activeNestedCollapse = this.activeNestedCollapse === nestedIndex ? null : nestedIndex;
        // this.isActiveTab(0)
        this.selected_hubid = nestedItem.hub_id;
        this.selected_vehicle = nestedItem.vehicle_id;
        this.activeTab = 0;
        this.dailyTrip('Mps')
        this.startMPSLoadApiCall();
      },
      isActiveTab(id) {
        return this.activeTab === id
      },
      // ----------- MPS Level Start ----------------------
    
      dailyTrip(status) {
        this.isLoading=true;
        this.isBusy = true;
        this.selected_status=status;
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
	    if(this.selected_status=="Mps"){
        this.tripItems=[];
        this.tripfields=[
          // { key: 'tripid', label: 'Trip ID', sortable: true},
          { key: 'parentawb', label: 'AWB No.', sortable: true},
          { key: 'shippingid', label: 'Shipping Id', sortable: true},
          
          { key: 'boxcount', label: 'Box Count', sortable: true},          
          { key: 'mpsweight', label: 'MPS Weight', sortable: true },    
          { key: 'sourcepincode', label: 'Source Pin', sortable: true },
          { key: 'destinationpincode', label: 'Destination Pin', sortable: true },
          { key: 'destinationcity', label: 'Destination City', sortable: true },
          { key: 'actions', label: ' Action' },
       ];
        
      }
      if(this.selected_status=="Load"){
          if(this.isvisibledataselect==true){
                this.tripItems=[];        
                this.tripfields=[
                    { key: 'checkbox', label: 'Select', sortable: true},
                    { key: 'parentawb', label: 'AWB No.', sortable: true},
                    { key: 'loadweight', label: 'Load Weight', sortable: true },
                    { key: 'loadvolumetricweight', label: 'Load Volume Weight', sortable: true },    
                    { key: 'mpscount', label: 'Box Count', sortable: true},
                    { key: 'sourcepincode', label: 'Source Pin', sortable: true },
                    { key: 'destinationpincode', label: 'Destination Pin', sortable: true },
                    { key: 'destinationcity', label: 'Destination City', sortable: true },
                    { key: 'loadpotype', label: 'Load Type', sortable: true },
                    { key: 'actions', label: ' Action' },
                    { key: 'download', label: ' DownloadEwayBill' },
                ];
            }
            else{
                this.tripItems=[];        
                this.tripfields=[
                    { key: 'parentawb', label: 'AWB No.', sortable: true},
                    { key: 'loadweight', label: 'Load Weight', sortable: true },
                    { key: 'loadvolumetricweight', label: 'Load Volume Weight', sortable: true },    
                    { key: 'mpscount', label: 'Box Count', sortable: true},
                    { key: 'sourcepincode', label: 'Source Pin', sortable: true },
                    { key: 'destinationpincode', label: 'Destination Pin', sortable: true },
                    { key: 'destinationcity', label: 'Destination City', sortable: true },
                    { key: 'loadpotype', label: 'Load Type', sortable: true },
                    { key: 'actions', label: ' Action' },
                    { key: 'download', label: ' DownloadEwayBill' },
                ];
            }
      }
      const Obj={
         
          vehicle_id:`${this.selected_vehicle}`,
          type:this.selected_status,
          sysusermasterid:`${userInfo.sysusermasterid}`,
          hub_id: userInfo.user_type == 1 ? `${this.selected_hubid}` : `${userInfo.hub_id}`
        }
        console.log(Obj)
        // return false;
        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getVehicleWiseMpsOrLoadListFromTemporaryTripDetails`, Obj).then((result) => {
          this.isBusy = false;
          this.isLoading=false;
          if (result.body.returnmsg === 'Successful') {
            this.tripItems = result.body.returnvalue;
            this.loaditem = result.body.returnvalue[0];
            this.totalRows = result.body.returnvalue.length;
            this.all_doc_flag=result.body.all_doc_flag
          } else {
            this.tripItems = [];
            this.loaditem = [];
            this.totalRows = 0;
          }
        })
      },
      startMPSLoadApiCall() {
        this.apiMPSCallAllowed = true; // Allow API calls on this route
        this.getMpsOrLoadListCount();
      },
      getMpsOrLoadListCount() {
        this.MpsOrLoadListCount=0;
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        const Obj = {
          vehicle_id: `${this.selected_vehicle}`,
          type: this.selected_status,
          sysusermasterid: `${userInfo.sysusermasterid}`,
          hub_id: userInfo.user_type == 1 ? `${this.selected_hubid}` : `${userInfo.hub_id}`,
        }
        // console.log(Obj)
        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getMpsOrLoadListCount`, Obj).then(result => {
          this.isLoading = false;
          if (result.body.returnmsg === "Successful") {
            this.MpsOrLoadListCount = result.body.returnvalue[0].list_count;
            if (this.apiMPSCallAllowed) {
              this.mpsTimeout = setTimeout(() => {
                this.getMpsOrLoadListCount();
              }, 15000); // 15 seconds
            }
            // console.log("this.Lwvwlleee@@@@@@@@@@",this.totalRows,this.MpsOrLoadListCount);
            if (this.totalRows != parseInt(this.MpsOrLoadListCount) && this.totalRows !=0) {
              this.dailyTrip(this.selected_status);
            }
          } else {
            this.MpsOrLoadListCount = 0;
          }
        }).catch(ex => {
          console.log("error", ex);
        });
      },
      downloadEwayBill(data){
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/downloadConsolidatedEwaybill`,data)
            .then(result=>{
                const base64String = result.data;
                const binaryString = window.atob(base64String);
                const uint8Array = new Uint8Array(binaryString.length);
                for (let i = 0; i < binaryString.length; i++) {
                    uint8Array[i] = binaryString.charCodeAt(i);
                }
                const blob = new Blob([uint8Array], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                this.dailyTrip(this.selected_status);
                window.open(url, '_blank');
                this.updateDowloadFlag(data)

            })
            .catch(error=>{
                this.$fire({text:'Error In Downloading Consolidated E-way Bill!',type: "error",timer: 30000})
            })
        },
        
        checkbuttonvisible(){
          // alert("Inn");
            this.isvisibledataselect = !this.isvisibledataselect;
            this.submitbuttonvisible = false;
            if (this.isvisibledataselect==false) {
            this.isCheckAll = false;
            this.selectparentawb = [];
            }
            this.dailyTrip(this.selected_status);
        },
  
        checkAll: function(){
    
            this.isCheckAll = !this.isCheckAll;
            this.selectparentawb = [];
            if(this.isCheckAll){ 
                for (var key in this.tripItems) {
                    this.selectparentawb.push(this.tripItems[key].parentawb);
                }
            }
        },
  
        updateCheckall: function(){
            if(this.selectparentawb.length == this.tripItems.length){
                this.isCheckAll = true;
            }else{
                this.isCheckAll = false;
            }
        },

       

        deallocateShipmentConfirm(parentAWB){
            this.$confirm("Are you sure you want to deallocate load?")
            .then(() => {
                this.deallocateShipment(parentAWB)
            })
            .catch(err=>{
                console.log('deallocateShipmentConfirm canceled----->',err)
            })
            
        },

        deallocateShipment(parentAWB){
            this.isLoading=true;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            
            const Obj={
    
                sysusermasterid:`${userInfo.sysusermasterid}`,
                parentawb:parentAWB,
                hub_id: userInfo.user_type == 1 ? `${this.selected_hubid}` : `${userInfo.hub_id}`,
                createdby : `${userInfo.userfirstname+' '+userInfo.userlastname}`
            }
            console.log("--------------------",Obj)
            // return false;
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deallocateMpsOrLoadListFromTemporaryTripDetails`,Obj).then((result)=>{
                this.isLoading=false;
                if (result.body.returnmsg === 'Successful') {
                    this.$fire({
                        text:result.body.returnvalue,
                        type: "success",
                        timer: 30000
                    });
                    this.dailyTrip(this.selected_status);
                }else{
                    this.$fire({
                        text:result.body.returnvalue,
                        type: "error",
                        timer: 30000
                    });
                }
            })
        },
    
        opennomodel(){
            this.noModal = !this.noModal;
        },
    
        nomodelclose(){
            this.submitbuttonvisible = !this.submitbuttonvisible;
            this.isvisibledataselect = false;
            this.isCheckAll = false;
            this.selectparentawb = [];
            this.noModal = false;
        },
    
        nomodelCancel(){
            this.submitbuttonvisible = false;
            this.isvisibledataselect = false;
            this.isCheckAll = false;
            this.selectparentawb = [];
            this.noModal = false;
            this.dailyTrip(this.selected_status);
        },
    
        clicknobutton(){
          // alert("inn");
            this.isCheckAll = false;
            this.selectparentawb = [];
            this.opennomodel();
        },
    
        openmodeldirectMode(){
            this.directModemodel = ! this.directModemodel;
        },
    
        directmodelclose(){
            this.submitbuttonvisible = false;
            this.isvisibledataselect = false;
            this.isCheckAll = false;
            this.selectparentawb = [];
            this.directModemodel = false;
            this.dailyTrip(this.selected_status);
        },

        submitTrip(scope,tripid) {
            this.$validator.validateAll(scope).then(result => {
            if(result){
                this.getvalidateTripForAll_MpsScanForAllLoad(tripid)
            }
            })
        },
    
        getvalidateTripForAll_MpsScanForAllLoad(tripid){
            this.isLoading=true;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            
            const Obj={
    
                sysusermasterid:`${userInfo.sysusermasterid}`,
                tripid:tripid,
                hub_id: userInfo.user_type == 1 ? `${this.selected_hubid}` : `${userInfo.hub_id}`,
            }
            // return false;
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/validateTripForAllMpsScanForAllLoad`,Obj).then((result)=>{
                this.isLoading=false;
                console.log("===========================",result)
                if (result.body.returnmsg === 'Successful') {
                    
                    this.AllocateLoadToVehicleForOFDForCMS(tripid)
                }else{
                  console.log("----------------------")
                  let showtableFlag = result.body.showpopupflag;
                  console.log("showtableFlag",showtableFlag)
                  // if (showtableFlag=='Yes') {
                  //   const invalidShipmentData = result.body.returnvalue.invalid_shipment;
                  //   this.$fire({
                  //     title:"Invalid Shipment",
                  //     html: `
                  //       <table border="1" style="width: 100%; border-collapse: collapse;">
                  //           <tr>
                  //               <th style="padding: 8px; background-color: #f2f2f2;">Invalid Shipment</th>
                  //               <th style="padding: 8px; background-color: #f2f2f2;">Expirydate</th>
                  //               <th style="padding: 8px; background-color: #f2f2f2;">EBN</th>
                  //               <th style="padding: 8px; background-color: #f2f2f2;">EBN Generate</th>
                  //           </tr>
                  //           ${this.parseInvalidShipments(invalidShipmentData)}
                  //       </table>
                  //     `,
                  //     type: "error",
                  //     timer: 30000
                  //   });
                  //   this.showInvalidModal = true;

                  // } 
                  if (showtableFlag === 'Yes') {
                    const invalidShipmentData = result.body.returnvalue.invalid_shipment;

                    // Prepare table rows using your method
                    this.invalidShipmentTableHtml = this.parseInvalidShipments(invalidShipmentData);

                    // Show modal
                    this.showInvalidModal = true;
                  }
                  else {
                    this.$fire({
                        text:"Invalid Shipment - " + result.body.returnvalue.invalid_shipment,
                        type: "error",
                        timer: 30000
                    });
                  }
                
                    this.submitbuttonvisible = false;
                    this.isvisibledataselect = false;
                    this.isCheckAll = false;
                    this.selectparentawb = [];
                    this.directModemodel = false;
                    this.dailyTrip(this.selected_status);
                }
            })
        },
        
       // Method to parse the invalid_shipment string and return rows for the table
       parseInvalidShipments(invalidShipments) {
          const shipments = invalidShipments.split(',');
          let rows = '';
          console.log("shipment",shipments)

          shipments.forEach(shipment => {
            // Extract shipment ID and details (split by '=' instead of ',')
            const parts = shipment.split('=');
            const shipmentId = parts[0];
            
            // Now split by '=' to get Expirydate and EBN
            const expirydate = parts[1].split('->')[1];
            const ebn = parts[2].split('->')[1];

            // Build a table row for each shipment

            const isEmpty = value =>
            value === undefined || value === null || String(value).trim() === '' || value === 'null' || value === 'undefined';

            const currentDate = new Date();

            // Assuming expirydate and ebn are your variables
            const showButton = (isEmpty(expirydate)) || (isEmpty(expirydate) && isEmpty(ebn)) ||
            (!isEmpty(expirydate) && currentDate > new Date(expirydate));


            rows += `
              <tr>
                  <td style="padding: 8px;">${shipmentId}</td>
                  <td style="padding: 8px;">${expirydate}</td>
                  <td style="padding: 8px;">${ebn}</td>
                  <td style="padding: 8px;">
                     ${showButton ? `<button onclick="generateEBN('${shipmentId}')" style="background-color: #4CAF50; color: white; border: none; padding: 6px 6px; border-radius: 4px; cursor: pointer;">Generate</button>` : ''}
                  </td>
              </tr>
            `;
          });

          return rows;
        },

        generateEBN(value){
        
          this.isLoading=true;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            
            const Obj={
    
              parentawb:`${value}`,
            }
            // return false;
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/generateEwayBillNumberByCMS`,Obj).then((result)=>{
                this.isLoading=false;
                if (result.body.returnmsg === 'Successful') {
                    this.$fire({
                        text:result.body.returnvalue,
                        type: "success",
                        timer: 30000
                    });
                    
                }
                else if (result.body.msg=="2"){
                  this.$fire({
                        text:result.body.result,
                        type: "success",
                        timer: 30000
                    });
                }
                else{
                    this.$fire({
                        text:result.body.returnvalue,
                        type: "error",
                        timer: 30000
                    });
                   
                }
            })
        },

        AllocateLoadToVehicleForOFDForCMS(tripid){
            this.isLoading=true;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            
            const Obj={
    
                sysusermasterid:`${userInfo.sysusermasterid}`,
                tripid:tripid,
                createdby:userInfo.userfirstname + ' ' + userInfo.userlastname,
                hub_id: userInfo.user_type == 1 ? `${this.selected_hubid}` : `${userInfo.hub_id}`,
            }
            // return false;
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/AllocateLoadToVehicleForOFDForCMS`,Obj).then((result)=>{
                this.isLoading=false;
                if (result.body.returnmsg === 'Successful') {
                    this.$fire({
                        text:result.body.returnvalue,
                        type: "success",
                        timer: 30000
                    });
                    this.submitbuttonvisible = false;
                    this.isvisibledataselect = false;
                    this.isCheckAll = false;
                    this.selectparentawb = [];
                    this.directModemodel = false;
                    this.dailyTrip(this.selected_status);
                    
                }else{
                    this.$fire({
                        text:result.body.returnvalue,
                        type: "error",
                        timer: 30000
                    });
                    this.submitbuttonvisible = false;
                    this.isvisibledataselect = false;
                    this.isCheckAll = false;
                    this.selectparentawb = [];
                    this.directModemodel = false;
                    this.dailyTrip(this.selected_status);
                }
            })
        },
    
        directMode(){    
            this.isLoading=true;
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
          
        const Obj={
            hubid:'',
            deliverymode:'Direct',
            allparentawbs:this.selectparentawb,
        }
          console.log("Obj",Obj);
          // return false
          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/updateDeliveryModeOfLoads`,Obj).then((result)=>{
              console.log("Result",result);
              this.isLoading=false;
              // return false
              if (result.body.returnmsg === 'Successful') {
                  this.getvalidateTripForAll_MpsScanForAllLoad(this.loaditem.tripid)
                  this.directModemodel = ! this.directModemodel;
                    this.selectparentawb=[];
                    this.isCheckAll = false;
              }else{
                this.$fire({
                    text:result.body.returnvalue,
                    type: "error",
                    timer: 30000
                  });
              }
          })
        },

        viewProduct:function(value){
            this.isLoading=true;
            this.mpscurrentPage=1;
            this.productdetailsModal=true;
            this.isBusyMps = true;
            let userData = localStorage.getItem('userData');
            let userInfo = JSON.parse(userData);
            
            
            
            let obj = {
                parentawb: value.parentawb,
            }
            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getMPSListFromLoad`,obj)
                .then(result => {
                    this.isLoading=false;
                    this.isBusyMps = false;
                    if(result.body.returnmsg === "successful"){
                    
                    this.mpsitems  = result.body.returnvalue;
                        this.mpstotalRows = result.body.returnvalue.length;
                    
                    }else {
                    this.mpsitems  = [];
                    this.mpstotalRows = 0
                    }
                }).catch(ex => {
                    console.log('error', ex)
                })
            
        },
            
        modalCancel:function(){
            this.productdetailsModal=false;
        },

        vehicleDrawerClose(){
          
          this.apiMPSCallAllowed=false;
          this.mpsTimeout=null;
        },
        updateDowloadFlag(item){
        //  console.log("Innnnnnnnnnnn",item);
         let downloadObj={
          parentawb:`${item.parentawb}`
         }
         this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/updateDownloadFlag`,downloadObj).then((response)=>{
          if(response.body.returnmsg =='Successful'){
             this.dailyTrip(this.selected_status)
          }else{
            this.$fire({
               text:`Error in Updating Flag`,
               type: "error",
               timer: 30000
              });
          }  
         }).catch(err=>{
          console.error('err------------------->',err);
         })
        },
        downloadAllDocPdf(tripid){
        //  console.log("---------------------->",tripid);
        document.getElementById("overlay").style.display = "block";
         let doc_Obj={
          tripid:`${tripid}`
         }
         this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/downloadAllDocTripWise`,doc_Obj).then((result)=>{
          document.getElementById("overlay").style.display = "none";

                const base64String = result.data;
                const binaryString = window.atob(base64String);
                const uint8Array = new Uint8Array(binaryString.length);
                for (let i = 0; i < binaryString.length; i++) {
                    uint8Array[i] = binaryString.charCodeAt(i);
                }
                const blob = new Blob([uint8Array], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                window.open(url, '_blank');
                this.dailyTrip(this.selected_status);
                
         }).catch(err=>{
          console.error('err------------------->',err);
          this.$fire({text:'Error In Downloading All Document',type: "error",timer: 30000})
         })
        },
        rowClass(item, type) {
        if(item){
          if (item.download_again_flag==1) { 
              return 'table-success'
          }
        }
      },
      downloadDirectTaxillaEwayBill(item){
        document.getElementById("overlay").style.display = "block";
         let doc_Obj={
          ebn:`${item.ebn}`,
          awb:`${item.parentawb}`
         }
         this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/downloadDirectEwayBillFromTaxilla`,doc_Obj).then((response)=>{
          document.getElementById("overlay").style.display = "none";
         if(response.body.returnmsg =='Successful'){
          let url = response.body.returnvalue;
          window.open(url, '_blank');
          this.dailyTrip(this.selected_status);
         }else{
          this.$fire({text:'Error In Download',type: "error",timer: 30000})
         }
                
         }).catch(err=>{
          console.error('err------------------->',err);
          this.$fire({text:'Error In Download',type: "error",timer: 30000})
          document.getElementById("overlay").style.display = "none";
         })
      }
    },
    
  };
</script>
<style scoped>
  /* Add additional styling if needed */
</style>
